/** Tab ids for the client record (shared by route + OS window). */
export type ClientDetailTabId = "overview" | "tasks" | "plans" | "calculators" | "artifacts" | "activity";

const CLIENT_DETAIL_TABS: ClientDetailTabId[] = ["overview", "tasks", "plans", "calculators", "artifacts", "activity"];

export function parseClientDetailTab(value: unknown): ClientDetailTabId | undefined {
  if (typeof value !== "string") return undefined;
  return CLIENT_DETAIL_TABS.includes(value as ClientDetailTabId) ? (value as ClientDetailTabId) : undefined;
}
